module.exports = __webpack_public_path__ + "static/media/audio.edf504e8.svg";